import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AffiliateMarketingService } from '@api/affiliate-marketing.service';
import jalaliMoment = require('jalali-moment');
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-valid-time-setting',
  templateUrl: './valid-time-setting.component.html',
  styleUrls: ['./valid-time-setting.component.scss']
})
export class ValidTimeSettingComponent implements OnInit {
  public destroy$ = new Subject<void>();
  settingTime;
  updatedDate;
  submiteMode = false;
  formSettingTime: FormGroup;
  constructor(
    private affiliateMarketingService: AffiliateMarketingService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.initialForm();
    this.getTimeSetting();
  }
  initialForm() {
    this.formSettingTime = this.formBuilder.group({
      fromHour24: [null, []],
      toHoure24: [null, []],
    })
  }
  getTimeSetting() {
    this.affiliateMarketingService.getSettingPaymentTime().pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.settingTime = res;
        this.updatedDate = jalaliMoment(this.settingTime?.updatedDate).format('jYYYY/jMM/jDD hh:mm');
        this.getInitialValue(this.settingTime);
      }
    )
  }
  getInitialValue(response){
    if(this.settingTime){
      this.formSettingTime.patchValue(response);
    }
  }

  changeTime(){
    this.affiliateMarketingService.changeDateInSetting(this.formSettingTime.value).subscribe(
      (res) => {
        if(res.status === 200){
          this.snackBar.open('زمان به درستی تغییر کرد', 'Undo', {
            duration: 1000
          })
          this.getTimeSetting()
        }
      })
      this.submiteMode = false;
  }

  edit(){
    this.submiteMode = true;
  }
}
